import { Button, Stack, Theme, Typography } from '@mui/material';

import { ProgressDots } from '@/components/DataDisplay/Indicator/ProgressDots';
import Logo from '@/components/Icon/Logo';
import { Screen } from '@/components/Layout/Screen';

import { useAppSelector } from '@/hooks/redux';
import { useAuthentication } from '@/hooks/useAuthentication';
import { useTranslate } from '@/hooks/useTranslate';

import { selectConfigsState } from '@/redux/configs/selectors';

import { getDataTestId } from '@/utils/browser';
import { PROGRESS_STEPS } from '@/utils/progressSteps';

const AddAdultDetailScreenComponent: React.FC = () => {
  const { t } = useTranslate();
  const { logo } = useAppSelector(selectConfigsState);
  const { onBackToSignIn } = useAuthentication();

  return (
    <Screen
      header={{
        centerSlot: (
          <ProgressDots
            value={PROGRESS_STEPS.thirdPartyComplianceCheckStep.value}
            total={PROGRESS_STEPS.thirdPartyComplianceCheckStep.total}
          />
        ),
      }}
      bgColor={(theme: Theme) => theme.palette.background.paper}
    >
      <Stack
        direction="column"
        gap={3}
        flex={1}
        justifyContent={'center'}
        alignItems={'center'}
      >
        <Logo src={logo} alt="Logo" />
        <Stack direction="column">
          <Typography variant="body2" textAlign={'center'}>
            {t('page.addAdultDetailResultFailed.content')}
          </Typography>
        </Stack>
      </Stack>
      <Button
        onClick={onBackToSignIn}
        {...getDataTestId('back-to-login-button')}
        variant="text"
      >
        {t('layout.page.button.backToLogin')}
      </Button>
    </Screen>
  );
};

export default function AddAdultDetailResultFailedScreen() {
  return <AddAdultDetailScreenComponent />;
}
